import ActionTimeline from "./ActionTimeline";
import Avatar from "./Avatar";
import BGLoading from "./BGLoading";
import CofirmBox from "./CofirmBox";
import EventItem from "./EventItem";
import LabelValue from "./LabelValue";
import Loading from "./Loading";
import PaginationCustom from "./PaginationCustom";
import SeatGrid from "./SeatGrid";
import StatusLabel from "./StatusLabel";
import StatusShowInfo from "./StatusShowInfo";
import ZoneAreaEditor from "./ZoneAreaEditor";

const EXPORT = {
  ActionTimeline,
  Avatar,
  BGLoading,
  CofirmBox,
  EventItem,
  LabelValue,
  Loading,
  PaginationCustom,
  SeatGrid,
  StatusLabel,
  StatusShowInfo,
  ZoneAreaEditor,
};

export default EXPORT;
